import useGetMyAccountSettings from './useGetMyAccountSettings';

const useGetMyAccountExternalPaymentRedirectUrl = () => {
  const { account, ...rest } = useGetMyAccountSettings();

  return {
    externalPaymentRedirectUrl: account?.externalPaymentRedirectUrl ?? null,
    ...rest,
  };
};

export default useGetMyAccountExternalPaymentRedirectUrl;
